import WelcomeBackHomepageFirstFoldConfig from "./welcome-back-homepage-first-fold-config";
import WelcomeBackHomepageFirstFoldAdvancedConfig from "./welcome-back-homepage-first-fold-advanced-config";
import dynamic from "next/dynamic";
const WelcomeBackHomepageFirstFoldComponent = dynamic(()=>import("./welcome-back-homepage-first-fold-component"));
export default {
    WelcomeBackHomepageFirstFoldComponent,
    WelcomeBackHomepageFirstFoldConfig,
    WelcomeBackHomepageFirstFoldAdvancedConfig
};
